export class PnetSubmitQuoteUpdateModel {
  constructor() {
    this.quoteId = ''
    this.repairStatus = ''
    this.description = ''
    this.jobEnd = null
    this.timezoneOffset = -new Date().getTimezoneOffset() / 60
  }
}
